import { EstimateBalanceWorkflowStatus } from './estimate-balance'

export type BalanceChipColor = 'primary' | 'accent' | 'warn' | 'muted'

export function workflowStatusChipColor(status: EstimateBalanceWorkflowStatus): BalanceChipColor {
  switch (status) {
    case EstimateBalanceWorkflowStatus.DRAFT: {
      return 'warn'
    }
    case EstimateBalanceWorkflowStatus.CONFIRMED: {
      return 'primary'
    }
    case EstimateBalanceWorkflowStatus.NA: {
      return 'muted'
    }
    case EstimateBalanceWorkflowStatus.NOT_READY: {
      return 'warn'
    }
    case EstimateBalanceWorkflowStatus.NOT_STARTED: {
      return 'muted'
    }
  }
}
